module.exports = __webpack_public_path__ + "img/2-section-solar-powerwall.a1e04a41.jpeg";